import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  marketingPreferences: {
    email: false,
    telephone: false,
    text: false,
    post: false
  },
  meterReadPreferences: {
    electric: null,
    gas: null
  }
};

export const slice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.marketingPreferences = initialState.marketingPreferences;
    },
    setMarketingPreferences: (state, { payload }) => {
      state.marketingPreferences = {
        ...state.marketingPreferences,
        ...payload
      };
    },
    setMeterReadPreferences: (state, { payload }) => {
      const { fuel, value } = payload;
      state.meterReadPreferences[fuel] = value;
    }
  }
});

export const {
  setMeterReadPreferences,
  setMarketingPreferences,
  setInitialState
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectMarketingPreferences = (state) =>
  selectSlice(state).marketingPreferences;
export const selectMeterReadPreferences = (state) =>
  selectSlice(state).meterReadPreferences;

export default slice.reducer;
